import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api/client';
import { companyCamEndpoints } from '@/lib/api/endpoints';
import { companyCamKeys } from '@/lib/queryKeys';

export function useDisconnectCompanyCam() {
  const queryClient = useQueryClient();
  return useApiMutation<void, void>({
    mutationFn: () =>
      apiDelete<void>(operationsClient, companyCamEndpoints.connection()),
    onSuccess: () => {
      // Both the card's status and the settings panel read stale data
      // otherwise; `all()` covers each of them.
      void queryClient.invalidateQueries({ queryKey: companyCamKeys.all() });
      toast.success('CompanyCam disconnected');
    },
  });
}
